import React from "react";
import { StyledEyeBrown, StyledEyeBrownContainer } from './eyeBrow.style';
import Box from 'component/layoutComponents/Box';
import { Tooltip } from "@mui/material";

export interface IStyledEyeBrowProps{
  text?: any,
  icon?: any,
  color?: any,
  backgroundColor?: any,
  uppercase?: boolean,
  minHeight?: any,
  position?: any,
  width?: any,
  fontSize?: any,
  eyeBrownMinHeight?: any,
  marginBottom?: any,
  marginRight?: any,
  isHidden?: boolean,
  isIconFront?: boolean;
  height?: string;
  padding?: string;
  fontWeight?: number | string;
  id?: string;
};
const EyeBrow: React.FC<IStyledEyeBrowProps> = (props):JSX.Element => {
const { 
  text, 
  icon, 
  color, 
  backgroundColor, 
  uppercase, 
  minHeight, 
  position, 
  width, 
  fontSize, 
  marginBottom, 
  marginRight, 
  isHidden, 
  isIconFront,
  height,
  padding,
  fontWeight,
  id,
  ...rest
} = props;
return (
    <StyledEyeBrownContainer eyeBrownMinHeight={minHeight} className="eyebrow" tabIndex={0}>
      <StyledEyeBrown 
        eyeBrowFontSize={fontSize} 
        eyeBrownWidth={width} 
        backgroundColor={backgroundColor} 
        textColor={color} 
        uppercase={uppercase} 
        eyeBrownPosition={position}
        eyeBrownMarginBottom={marginBottom}  
        eyeBrownMarginRight={marginRight}
        isHidden={isHidden}
        isIconFront={isIconFront}
        height={height}
        padding={padding}
        fontWeight={fontWeight}
        id={id}
        {...rest}
      >
        {icon}
        <Tooltip title={text} arrow placement="bottom-start">
          <Box id='dv-eyebrow-text' className="eyebrowText">
            {text}
          </Box>
        </Tooltip>
      </StyledEyeBrown>
    </StyledEyeBrownContainer>
  );
};

EyeBrow.defaultProps = {
  text: "News",
  color: "#5f249f",
  backgroundColor: "#e9e0f7",
  uppercase: true,
  isHidden: false,
  isIconFront: true,
};

export default EyeBrow;